import { Spin } from 'antd'
import React, { Suspense } from 'react'
import LoadingPage from '../components/LoadingPage'

export const withLoading = (Component) => {
    return (props) => (
        <Suspense fallback={<LoadingPage />}>
            <Component {...props} />
        </Suspense>
    )
}


